import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getPlaygroundProject, type PlaygroundProjectDetail } from "../auth/api-client";
import { useAuth } from "../auth/AuthContext";
import { PlaygroundBody } from "./PlaygroundBody";

export default function PlaygroundIdePage() {
  const { projectId } = useParams();
  const { profile, getBearerToken } = useAuth();
  const bearer = getBearerToken();
  const isTeacher = profile?.role === "teacher";
  const eyebrow = isTeacher ? "Teacher · Playground" : "Student · Playground";
  const playgroundsHome = isTeacher ? "/teacher/playground" : "/playground";

  const [project, setProject] = useState<PlaygroundProjectDetail | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!bearer || !projectId) return;
    let cancelled = false;
    void (async () => {
      try {
        const data = await getPlaygroundProject(bearer, projectId);
        if (!cancelled) setProject(data.project);
      } catch (e) {
        if (!cancelled) setError(e instanceof Error ? e.message : "Could not load the project");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [bearer, projectId]);

  if (error) {
    return (
      <main className="page page-align-start">
        <div className="card card-wide">
          <div className="warn-banner" role="alert">
            {error}
          </div>
          <p className="fineprint">
            <Link to={playgroundsHome}>← Back to playgrounds</Link>
          </p>
        </div>
      </main>
    );
  }

  if (!project) {
    return (
      <main className="page page-align-start">
        <div className="card card-wide">
          <p className="muted">Loading project…</p>
        </div>
      </main>
    );
  }

  return (
    <PlaygroundBody
      eyebrow={eyebrow}
      title={project.title}
      backTo={playgroundsHome}
      backLabel="Playgrounds"
      projectId={project.id}
      initialFiles={project.files}
    />
  );
}
